import React, { ReactNode } from "react";
import { MappedEvent, ResultsFormattedData } from "@data-types/results";
import {
	ResultsContext,
	ResultsTournamentContext,
} from "@state/context/results";
import ResultsTableHeader from "./ResultsTableHeader";
import ResultsTableSubheader from "./ResultsTableSubheader";
import ResultsTableBody from "./ResultsTableBody";

export default function ResultsTablesList({
	resultData,
	children,
}: {
	resultData: ResultsFormattedData<Map<string, MappedEvent[]>>[];
	children?: ReactNode;
}) {
	return (
		<div className="card--primary__body">
			{resultData.map((result) => (
				<ResultsContext.Provider
					value={result}
					key={`${result.sport.id}-${result.sportCategory.id}`}
				>
					{result.tournaments.map((tournament) => (
						<ResultsTournamentContext.Provider
							key={`${result.sport.id}-${result.sportCategory.id}-${tournament.id}`}
							value={tournament}
						>
							<table
								className={`table--results table--results--${result.sport.abrv}`}
							>
								<ResultsTableHeader>
									{children}
								</ResultsTableHeader>

								<ResultsTableSubheader />

								<ResultsTableBody />
							</table>
						</ResultsTournamentContext.Provider>
					))}
				</ResultsContext.Provider>
			))}
		</div>
	);
}
